<template>
  <!-- 校审存放目录弹框 -->
  <el-dialog v-dialogDrag :visible.sync="dialogShow" title="存放目录" width="600px">
    <el-tree ref="frameTree" :data="frameTree" :props="defaultProps" :expand-on-click-node="false" class="tree"
      node-key="folderId" accordion highlight-current :default-expanded-keys="frameTreeDefaultExpandedKeys"
      @node-click="ChangeHandler"
      @node-expand="treeExpand" @node-collapse="treeCollapse">
      <template #default="{ data }">
        <span class="treeitem">
          <img :src="icon" style="margin-right: 6px" alt="文件" />
          <span> {{ data.folderName }}</span>
        </span>
      </template>
    </el-tree>
    <!-- 页脚 -->
    <span slot="footer" class="dialog-footer">
      <div style="display: flex;justify-content: space-between;">
        <div>
          <el-button v-if="isShowAddFolder && addXtDesign" type="primary" size="small" plain
            @click="addFolder">新建文件夹</el-button>
        </div>
        <div>
          <el-button size="small" @click="dialogShow = false">取 消</el-button>
          <el-button type="primary" size="small" @click="recelocationBtn">确 定</el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import approval from "@/CommonDP/service/approve-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import docService from "@/CommonDP/service/doc-service";
export default {
  components: {},
  props: ["curSpecId"],
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      dialogShow: false, // 弹框显隐
      defaultProps: {
        label: "folderName",
        isLeaf: "leaf",
        children: "childList"
      },
      currentDepartment: {}, // 存放选中
      RootNode: [{ folderName: "成品区", id: "1630981811371", childList: [] }], // 根节点
      frameTree: [],
      frameTreeDefaultExpandedKeys: [],
      list: [],
      addXtDesign: checkPermission(this.$allPerms.XTDESIGN_ADD)
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams
    }),
    isShowAddFolder() {
      const data = this.currentDepartment || {};
      const isShow = data.folderType ? data.folderType !== 13 && data.folderType !== 16 && data.folderType !== 14 && data.folderType !== 18 : false;
      return data.folderNew === 1 && isShow;
    }
  },
  mounted() {},
  methods: {
    treeExpand(data, node) {
      node.isExpand = true;
      this.currentDepartment = data;
    },
    treeCollapse(data, node) {
      node.isExpand = false;
      this.currentDepartment = data;
    },
    addFolder() {
      const { folderId } = this.currentDepartment;
      this.$prompt("", "新建文件夹", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入文件夹名称",
        inputPattern: /^\S*$/,
        inputErrorMessage: "文件夹名称不能包含空格",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        inputValidator: value => {
          if (!value) {
            return "文件夹名称不能为空";
          }
          if (value.length > 80) {
            return "文件夹名称不能大于80个字符";
          }
          var regExp = new RegExp('[\\\\|/:*<>?"]');
          if (regExp.test(value)) {
            return '文件夹名称不能包含以下字符:\\ / : * " ? < > |';
          }
        },
        center: true
      })
        .then(async ({ value }) => {
          const prjId = this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId;
          const parentId = folderId;
          const folderName = value.replace(/\s*/g, "");
          const data = { parentId, folderName, prjId };
          const result = await docService.queryAddFolder(data);
          if (result.result === "0") {
            this.$message.success("新建成功");
            this.getFrameTree();
          }
        })
        .catch(() => {});
    },
    // 获取存放目录
    async getFrameTree() {
      this.frameTree = [];
      const params = {
        prjId: this.routerParams.prjId || this.prjInfo.prjId,
        isRead: 1,
        priviAll: 0,
        folderId: "1630981811371",
        level: 99
      };
      await approval.docList(params).then(async ({ data }) => {
        this.list = data;
        this.RootNode[0].childList = this.frameTreeFilter(this.list);
        this.frameTree = this.RootNode;
        this.$nextTick(() => {
          this.frameTreeDefaultExpandedKeys = [this.currentDepartment.folderId];
          this.$refs.frameTree.setCurrentKey(this.currentDepartment.folderId);
          this.currentDepartment = this.$refs.frameTree.getCurrentNode();
        });
      });
    },
    frameTreeFilter (list) {
      return list.filter(item => {
        if (item.childList !== null) {
          item.childList = this.frameTreeFilter(item.childList);
        }
        return item.isFolder === 1 && (item.specId === "0" || item.specId === "");
      });
    },
    // 点击行
    ChangeHandler(val) {
      this.currentDepartment = val;
    },
    // 存放目录确定
    recelocationBtn() {
      const obj = this.currentDepartment;
      if (!obj.folderId) {
        this.$message.warning("请选择文件夹");
        return;
      }
      if (obj.folderId == "1630981811371") {
        this.$message.warning("请选择成品区下面的文件作为存放目录");
        return;
      }
      if (obj.isReadOnly == 1) {
        this.$message.warning("系统文件夹非最底级不可存放文件，请重新选择");
        return;
      }
      this.$emit("setFileLocation", obj);
      this.dialogShow = false;
    }
  }
};
</script>

<style lang='scss' scoped>
.tree {
  width: 100%;
  height: 400px;
  overflow: auto;

  .treeitem {
    display: flex;
    align-items: center;
    user-select: none;
  }
}
</style>
